var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"text-sm font-medium rounded-lg select-none transition hover:opacity-70",class:(this.size === 'Lg' ? 'py-4 px-6' : '') + ' '
        + (this.size === 'Sm' ? 'py-3 px-4' : '') + ' '
        + (this.size === '0' ? 'p-0' : '') + ' '
        + this.flex + ' ',on:{"click":function($event){return _vm.$emit('wasClicked')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }